// extracted by mini-css-extract-plugin
module.exports = {"label":"project-card_label__29x2z","outlined-btn":"project-card_outlined-btn__3qbjo","active":"project-card_active__3c82K"};